import { render, staticRenderFns } from "./EmiratisationStatistics.vue?vue&type=template&id=071b87bc&scoped=true"
import script from "./EmiratisationStatistics.vue?vue&type=script&lang=ts"
export * from "./EmiratisationStatistics.vue?vue&type=script&lang=ts"
import style0 from "./EmiratisationStatistics.vue?vue&type=style&index=0&id=071b87bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071b87bc",
  null
  
)

export default component.exports